/**
 * Normalisation email — source unique pour TOUS les points d'entrée auth.
 *
 * Avant : login utilisait l'email brut, reset un trim() seul, OTP trim+lower,
 * invite lower seul → un email copié-collé avec espace ou casse échouait au
 * login (« Invalid login » trompeur). Supabase compare l'email en lower côté
 * serveur, mais ne supprime pas les espaces parasites → on normalise ici.
 */
export function normalizeEmail(raw: string): string {
  return raw.trim().toLowerCase()
}
